import { render } from "./ViewVision.vue?vue&type=template&id=8356fd6a"
import script from "./ViewVision.vue?vue&type=script&lang=js"
export * from "./ViewVision.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__